import React__default, { useState, useCallback } from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useSelector, useIntl } from '@grandvisionhq/state';
import { LoadingData } from '../LoadingData.js';
import { usePersonalDetails } from '../../hooks/use-personal-details.js';
import { usePreferredStore } from '../../hooks/use-preferred-store.js';
import { ErrorAlert } from '../ErrorAlert.js';
import PreferredStore from './PreferredStore.js';

const PreferredStoreContainer = ()=>{
    var ref;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showUpdateError, setShowUpdateError] = useState(false);
    const userId = useSelector(Selectors.getUserId);
    const intl = useIntl();
    const { isUpdating , updatePersonalDetails  } = usePersonalDetails({
        onCompleted: ()=>setShowUpdateError(false)
        ,
        onError: ()=>setShowUpdateError(true)
    });
    const { data: preferredStoreData , loading: storeLoading , error: storeError , refetch ,  } = usePreferredStore();
    const onOpenModal = useCallback(()=>{
        setIsModalOpen(true);
    }, []);
    const onCloseModal = useCallback(()=>{
        setIsModalOpen(false);
    }, []);
    const handleChangePreferredStore = useCallback((storeCode)=>{
        if (!userId) {
            return;
        }
        updatePersonalDetails({
            preferredStore: storeCode.toString()
        }, userId);
    }, [
        updatePersonalDetails,
        userId
    ]);
    const onStoreSelect = useCallback((store)=>{
        if (!store) {
            return;
        }
        onCloseModal();
        handleChangePreferredStore(store.code);
        refetch();
    }, [
        handleChangePreferredStore,
        onCloseModal,
        refetch
    ]);
    if (storeLoading || isUpdating) {
        return /*#__PURE__*/ React__default.createElement(LoadingData, null);
    }
    if (storeError) {
        return /*#__PURE__*/ React__default.createElement(ErrorAlert, {
            message: intl.getFormattedLabel('account.preferredStore.errors.network.general', {
                parseLink: true
            })
        });
    }
    const errorElement = showUpdateError ? /*#__PURE__*/ React__default.createElement(ErrorAlert, {
        message: intl.getFormattedLabel('account.preferredStore.errors.update.general', {
            parseLink: true
        })
    }) : null;
    const preferredStoreLabels = {
        noStoreSelected: intl.getLabel('account.profile.preferredStore.noStoreSelected'),
        addStore: intl.getLabel('account.profile.preferredStore.addStore'),
        error: intl.getFormattedLabel('account.profile.preferredStore.error'),
        modalTitle: intl.getLabel('checkout.component.storeListTopContent.title'),
        modalDescription: intl.getLabel('checkout.component.storeListTopContent.description')
    };
    return /*#__PURE__*/ React__default.createElement(PreferredStore, {
        storeCode: preferredStoreData === null || preferredStoreData === void 0 ? void 0 : (ref = preferredStoreData.storeCode) === null || ref === void 0 ? void 0 : ref.toString(),
        labels: preferredStoreLabels,
        errorElement: errorElement,
        isModalOpen: isModalOpen,
        onOpenModal: onOpenModal,
        onCloseModal: onCloseModal,
        onStoreSelect: onStoreSelect
    });
};
var PreferredStoreContainer$1 = PreferredStoreContainer;

export { PreferredStoreContainer$1 as default };
//# sourceMappingURL=PreferredStoreContainer.js.map
